import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import * as urls from '../utilities/urls';
import { NzTableData } from '../utilities/nz-table.adapter';
import { MerchantCategoryCodeSearch, MerchantTransactionSearch} from './../models/merchant-transactions';
// tslint:disable-next-line: max-line-length
import { TransactionAccountTypes} from '../utilities/common-file';
import { AuthService } from '../auth/auth.service';
@Injectable({
    providedIn: 'root',
})
export class TransactionService {
    constructor(private httpClient: HttpClient, private router: Router, private authService: AuthService ) {}

getTransactionsWithLimit(tableData: NzTableData<MerchantTransactionSearch, any>) {
  const value = {
    startDate: tableData.search.createdDate.startDate ? tableData.search.createdDate.startDate : '',
    endDate: tableData.search.createdDate.endDate ? tableData.search.createdDate.endDate : '',
    transactionStatus: tableData.search.transactionStatus,
    transactionType: tableData.search.transactionType,
    paymentMethod: tableData.search.paymentMethod,
    settlementStatus: tableData.search.settledStatus,
    isSettled: tableData.search.isSettled,
    accountTypeIn: tableData.search.accountType ? tableData.search.accountType :
    [TransactionAccountTypes.qrPayment, TransactionAccountTypes.externalPayment, TransactionAccountTypes.settlement,
   TransactionAccountTypes.refund],
   mobileNo: tableData.search.type === 'mobile_no' ? (tableData.search.number ? tableData.search.number.toString() : '')  : '',
   accountNo: tableData.search.type === 'account_no' ? tableData.search.number  : '',
    id: tableData.search.id ? parseInt(tableData.search.id) : '',
    name: tableData.search.name,
    merchantId: this.authService.getMerchantId(),
    locationId: tableData.search.locationId ? tableData.search.locationId : '',
    pageSize: tableData.pageSize,
    pageIndex: tableData.pageIndex
};
  return this.httpClient.post(urls.MerchantSettlementUrls.transactionsForSettlement, value);
}
downloadForTransactionReport(value) {
  return this.httpClient.post(urls.MerchantSettlementUrls.transactionsForSettlement, value);
}
// Get Settled Transactions
getSettledTransactions(tableData: NzTableData<MerchantTransactionSearch, any>) {
  const value = {
    merchantId: parseInt(this.authService.getMerchantId()),
    settlementDocId: tableData.search.id,
    includeMerchantLedgerRelations: false,
    pageSize: tableData.pageSize,
    pageIndex: tableData.pageIndex
};
  return this.httpClient.post(urls.MerchantSettlementUrls.transactionsForSettlement, value);
}
// Download Excel for transactions
downloadMerchantTransactionReport(value) {
  return this.httpClient.post(urls.MerchantSettlementUrls.transactionsForSettlement, value);
}
clearSearchFields(tableData: NzTableData<MerchantTransactionSearch, any>, value) {
  if (value === 'name') {
    return tableData.search.name = '';
  }
  if (value === 'id') {
    return tableData.search.id = '';
  }
  if (value === 'number') {
    return tableData.search.number = '';
  }
  }
doRefund(value) {
  return this.httpClient.post(urls.MerchantSettlementUrls.refundTrasaction, value);
}

// Get Merchant Transactions with page limit New Api
getMerchantTransactionListView(tableData: NzTableData<MerchantTransactionSearch, any>) { 
  const value = {
    appCode: tableData.search.appCode,
    startDate: tableData.search.createdDate.startDate ? tableData.search.createdDate.startDate : '',
    endDate: tableData.search.createdDate.endDate ? tableData.search.createdDate.endDate : '',
    transactionStatus: tableData.search.transactionStatus,
    isSettled: tableData.search.isSettled,
    paymentMethod: tableData.search.paymentMethod ? tableData.search.paymentMethod : '',
    // accountTypeIn: tableData.search.accountType ? tableData.search.accountType :
    //   [TransactionAccountTypes.qrPayment, TransactionAccountTypes.externalPayment, TransactionAccountTypes['MONTHLY-TRANSFER-FEE'],
    //   TransactionAccountTypes.refund],
     accountTypeIn: tableData.search.accountType ? tableData.search.accountType : [""],
    mobileNo: tableData.search.type === 'mobile_no' ? (tableData.search.number ? tableData.search.number.toString() : '') : '',
    accountNo: tableData.search.type === 'account_no' ? tableData.search.number : '',
    // tslint:disable-next-line: radix
    id: tableData.search.id ? parseInt(tableData.search.id) : '',
    name: tableData.search.name,
    merchantId: this.authService.getMerchantId(),
    locationId: tableData.search.locationId ? tableData.search.locationId : '',
    isOrderDelivered: tableData.search.isOrderDelivered ? tableData.search.isOrderDelivered : '',
    pageSize: tableData.pageSize,
    pageIndex: tableData.pageIndex,
    settlementDocId : tableData.search.settlementDocId ? tableData.search.settlementDocId : '',
  };
  return this.httpClient.post(urls.MerchantTransactionUrls.transactionList, value);
}
// Download Excel for transactions
downloadMerchantTransactionReportNew(value) {
  return this.httpClient.post(urls.MerchantTransactionUrls.transactionList, value);
}
merchantTransactionSummary(tableData: NzTableData<MerchantTransactionSearch, any>) {
  const value = {
    merchantId: tableData.search.merchantId ? tableData.search.merchantId : '',
    startDate: tableData.search.createdDate.startDate ? tableData.search.createdDate.startDate : '',
    endDate: tableData.search.createdDate.endDate ? tableData.search.createdDate.endDate : '',
    isSettled: tableData.search.isSettled,
    paymentMethod: tableData.search.paymentMethod ? tableData.search.paymentMethod : '',
    accountTypeIn: tableData.search.accountType ? tableData.search.accountType :
      [TransactionAccountTypes.qrPayment, TransactionAccountTypes.externalPayment, TransactionAccountTypes.settlement,
      TransactionAccountTypes.refund],
      mobileNo: tableData.search.type === 'mobile_no' ? (tableData.search.number ? tableData.search.number.toString() : '') : '',
      accountNo: tableData.search.type === 'account_no' ? tableData.search.number : '',
      name: tableData.search.name,
      locationId: tableData.search.locationId ? tableData.search.locationId : '',
      isOrderDelivered: tableData.search.isOrderDelivered ? tableData.search.isOrderDelivered : '',
      pageSize: tableData.pageSize,
      pageIndex: tableData.pageIndex,
      id:tableData.search.id ? tableData.search.id.toString() : ''
  };
  return this.httpClient.post(urls.MerchantTransactionUrls.summaryList, value);
}
merchantTransactionSummary2(tableData: NzTableData<MerchantTransactionSearch, any>) {
  const value = {
    merchantId: tableData.search.merchantId ? tableData.search.merchantId : '',
    startDate: tableData.search.createdDate.startDate ? tableData.search.createdDate.startDate : '',
    endDate: tableData.search.createdDate.endDate ? tableData.search.createdDate.endDate : '',
    isSettled: tableData.search.isSettled,
    paymentMethod: tableData.search.paymentMethod ? tableData.search.paymentMethod : '',
    // accountTypeIn: tableData.search.accountType ? tableData.search.accountType :
    //   [TransactionAccountTypes.qrPayment, TransactionAccountTypes.externalPayment, TransactionAccountTypes.settlement,
    //   TransactionAccountTypes.refund],
      accountTypeIn: tableData.search.accountType ? tableData.search.accountType :[""],
      mobileNo: tableData.search.type === 'mobile_no' ? (tableData.search.number ? tableData.search.number.toString() : '') : '',
      accountNo: tableData.search.type === 'account_no' ? tableData.search.number : '',
      name: tableData.search.name,
      locationId: tableData.search.locationId ? tableData.search.locationId : '',
      isOrderDelivered: tableData.search.isOrderDelivered ? tableData.search.isOrderDelivered : '',
      pageSize: tableData.pageSize,
      pageIndex: tableData.pageIndex,
      id:tableData.search.id ? tableData.search.id.toString() : ''
  };
  return this.httpClient.post(urls.MerchantTransactionUrls.summaryList, value);
}
viewMerchantTransactionBasedOnID(value) {
  return this.httpClient.post(urls.MerchantSettlementUrls.transactionsForSettlement, value);
}
getAddress(value){
  return this.httpClient.post(urls.MerchantSettlementUrls.list, value);
}
  getMerchantBusinessModelWithLimit() {
    const value = {
        pageSize: '',
        pageIndex: ''
    }
    return this.httpClient.post(urls.MerchantTransactionUrls.businessModelList, value);
  }
      //list merchant category code
    getMerchantCategoryWithLimit(tableData: NzTableData<MerchantCategoryCodeSearch, any>) {
        const value = {
            code: tableData.search.code ? tableData.search.code : '',
            description: tableData.search.description ? tableData.search.description : '',
            isProhibited: tableData.search.isProhibited,
            pageSize: tableData.pageSize,
            pageIndex: tableData.pageIndex
        };
        return this.httpClient.post(urls.MerchantTransactionUrls.codeList, value);
    }
}
